export default class AddProvider {
  constructor() {
    const manualForm = document.getElementById('create_cloud_account_manual');
    if (manualForm) {
      this.initManualForm(manualForm);
    }

    const autoForm = document.getElementById('create_cloud_account_auto');
    if (autoForm) {
      this.initAutoForm(autoForm);
    }
  }

  initManualForm(form) {
    const confirmCheckbox = form.querySelector(`#${ form.id }_provider_iam_user`)
    const awsCredentialsManualFieldsContainer = form.querySelector(`.aws-credentials-manual-fields`)
    confirmCheckbox.addEventListener(
      'change',
      (event) => this.toggleContainer(event.target.checked, awsCredentialsManualFieldsContainer)
    );
  }

  initAutoForm(form) {
    const regionSelect = form.querySelector(`#${ form.id }_aws_cf_region`);
    const confirmCheckbox = form.querySelector(`#${ form.id }_provider_iam_role`);
    const permissionsContainer = form.querySelector(`.aws-permissions-container`);
    const awsRoleFieldsContainer = form.querySelector(`.aws-role-auto-fields`);
    const launchCloudformationButtonContainer = form.querySelector('.launch-cloudformation-btn-container');
    const launchCloudformationButton = launchCloudformationButtonContainer.querySelector('.btn');

    const launchCloudformationQuery = launchCloudformationButtonContainer.dataset.query;

    regionSelect.addEventListener('change', (event) => {
      permissionsContainer.classList.remove('d-none');
      const region = event.target.value;
      launchCloudformationButton.setAttribute(
        'href',
        `https://${region}.console.aws.amazon.com/cloudformation/home?region=${region}#/stacks/quickcreate?${launchCloudformationQuery}`
        );
    });

    confirmCheckbox.addEventListener(
      'change',
      (event) => this.toggleContainer(event.target.checked, awsRoleFieldsContainer)
    );
  }

  toggleContainer(isChecked, container) {
    if (isChecked) {
      container.classList.remove('d-none');
    } else {
      container.classList.add('d-none');
    }
  }
}
